import React from "react"

import {
	Box,
	Chip,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
	Stack,
	Typography,
} from "@mui/material"

import Chart from "chart.js/auto"

import { Trans } from "@lingui/macro"

import { theme } from "index"

interface FinantialPanChartProps
{
	chartData: {
		year: number[]
	}[]
	selectValues: string[]
}
interface FinantialPanChartState
{
	selectedFilter: string
	selectedYears: string[]
}
export class FinancialPanChart extends React.Component<FinantialPanChartProps, FinantialPanChartState>
{
	private palette = theme.palette
	private chartRef: React.RefObject<HTMLCanvasElement> = React.createRef()
	private myChart: Chart | null = null
	private years: string[] = [
		"2023",
		"2022",
		"2021",
		"2020",
		"2019",
		"2018",
	]

	constructor(props: FinantialPanChartProps)
	{
		super(props)
		this.state = {
			selectedFilter: "",
			selectedYears: ["2023, 2022"],
		}
	}

	public componentDidMount()
	{
		this.createChart()
		window.addEventListener("resize", this.handleResize)
	}

	createChart = () => {
		const canvas = this.chartRef.current
		if(canvas) {
			const ctx = canvas.getContext("2d")
			if(ctx) {
				if(this.myChart) {
					this.myChart.destroy()
				}

				this.myChart = new Chart(ctx, {
					type: "line",
					data: {
						labels: [
							"Gennaio",
							"Febbraio",
							"Marzo",
							"Aprile",
							"Maggio",
							"Giugno",
							"Luglio",
							"Agosto",
							"Settembre",
							"Ottobre",
							"Novembre",
							"Dicembre",
						],
						datasets: [
							{
								label: "",
								data: this.props.chartData[0].year,
								borderColor: this.palette.secondary.main,
								borderWidth: 2,
								fill: false,
								pointBackgroundColor: this.palette.secondary.main,
								pointBorderColor: this.palette.background.default,
								pointBorderWidth: 0.8,
							},
							{
								label: "",
								data: this.props.chartData[1].year,
								borderColor: this.palette.success.main,
								borderWidth: 2,
								fill: false,
								pointBackgroundColor: this.palette.secondary.main,
								pointBorderColor: this.palette.background.default,
								pointBorderWidth: 0.8,
							},
						],
					},
					options: {
						aspectRatio: 0.75,
						maintainAspectRatio: false,
						plugins: {
							legend: {
								labels: {
									boxWidth: 0,
								},
							},
						},
						scales: {
							x: {
								grid: {
									display: false,
								},
							},
							y: {
								suggestedMin: 0,
								grid: {
									display: true,
								},
							},
						},
					},
				})
			}
		}
	}

	handleResize = () => {
		if(this.myChart) {
			this.myChart.resize()
		}
	}

	private handleChangeYears = (event: SelectChangeEvent<string[]>) => {
		const {
			target: {value},
		} = event

		this.setState(() => ({
			selectedYears: typeof value === "string" ? value.split(",") : value,
		}))
	}

	render()
	{
        return (
            <Box sx={{
                backgroundColor: this.palette.background.default,
                height: "100%",
                mt: 3
            }}>
                <div>
                    <Grid container>
                        <Grid item xs={4} />
                        <Grid item xs={2} style={{ justifyContent: "center", alignItems: 'center', display: 'flex', marginTop: 40}}>
                            <Stack direction={"column"}>
                                <Chip label={"2023"} color={"secondary"} sx={{fontSize: 24, color: "background.default", p: 1}}/>
                                <Typography textAlign={"center"} sx={{mt: 3}}>
                                    0,00€
                                </Typography>
                                <Typography textAlign={"center"}>
                                    <Trans id="financial-pan-chart.total-revenue">
                                        Fatturato totale
                                    </Trans>
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={2} style={{ justifyContent: "center", alignItems: 'center', display: 'flex', marginTop: 40}}>
                            <Stack direction={"column"}>
                                <Chip label={"2022"} color={"success"} sx={{fontSize: 24, color: "background.default", p: 1}}/>
                                <Typography textAlign={"center"} sx={{mt: 3}}>
                                    0,00€
                                </Typography>
                                <Typography textAlign={"center"}>
                                    <Trans id="financial-pan-chart.total-revenue">
                                        Fatturato totale
                                    </Trans>
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={1} />
                        <Grid item xs={3} style={{ justifyContent: "center", display: 'flex', marginTop: 30}}>
                            <FormControl>
                                <InputLabel id="compare-label">{"Confronta"}</InputLabel>
                                <Select multiple value={this.state.selectedYears} labelId={"compare-label"} label="Confronta" sx={{width: 250}} onChange={this.handleChangeYears}>
                                    {this.years.map((option) => (
                                        <MenuItem key={option} value={option}>{option}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>

                <Box sx={{
                    width: '90%',
                    mx: "auto",
                    mb: 5,
                    flexGrow: 1,
                }}>
                    <canvas ref={this.chartRef}></canvas>
                </Box>
            </Box>
        )
    }
}
